module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/CIVIL ENGINEERING-79b74611d83346b8c5bb7c0f03508242.png";